export const profile = {
  staff_id: null,
  first_name: "",
  last_name: "",
  phone_number: "",
  email: "",
  subject_id: [],
  class_id: null,
  educational_level: "",
  role: "",
  school_name: "",
  school_id: null,
  current_school: null,
  schools_assigned: [],
  accessToken: "",
  country: "",
  country_code: "",
};

export let dashboard = {
  totalstud: 0,
};

export let studentList = [];
